type Message = Record<string, unknown>;

const postMessage = (msg: string | Message) => {
    const parent = window.parent;
    const name = window.name;
    let message = msg;

    if (name) {
        if (typeof message === 'string') {
            // Костыль для тех, кто завязался на строковые сообщение от форм
            parent.postMessage(message, '*');

            message = {
                name: name,
                message: msg,
            };
        } else {
            message.name = name;
        }
    }

    if (typeof message !== 'string') {
        message = JSON.stringify(message);
    }

    parent.postMessage(message, '*');
};

export default postMessage;
